const fr = {
  nav: { about: "À propos", services: "Services", logistics: "Logistique", clients: "Clients", news: "Actualités", contact: "Contact", cta: "Demander un conseil", menu: "Menu", close: "Fermer" },
  global: {
    eyebrow: "Le monde en mouvement",
    title: "De la Côte aux _grandes capitales_.",
    intro: "Des gens qui font des affaires, des marchandises qui voyagent : voilà notre quotidien.",
    capitals: "Grandes capitales",
    deals: "Personnes & affaires",
    base: "Ma base : la Côte",
    ops: "Marchandises en route",
    timezones: "Fuseaux horaires",
    newsTicker: "Actualités du monde · toujours à jour · lisez plus bas dans Actualités & Marchés",
  },
  news: {
    eyebrow: "06 — Actualités & Marchés",
    title: "Le monde du transport, _en temps réel_.",
    intro: "Les titres mis à jour automatiquement depuis les principaux portails de la logistique internationale.",
    read: "Lire",
    updated: "Mis à jour",
  },
  hero: {
    eyebrow: "Conseil aux entreprises · Import Export · Logistique",
    lines: ["Nous portons", "les entreprises", "_au-delà_ des frontières."],
    sub: "Nous accompagnons les entreprises dans l'import-export, les procédures documentaires, l'entrée sur de nouveaux marchés et la logistique internationale : du premier contact à la livraison.",
    cta: "Parlons de votre projet",
    cta2: "Voir les services",
    scroll: "Défiler",
    tags: ["Mer", "Air", "Route", "Express"],
    frame: "Des routes mondiales, un seul interlocuteur",
  },
  marquee: ["Import · Export", "Procédures documentaires", "Température dirigée", "Marchandises dangereuses DGR", "Fret maritime", "Fret aérien", "Transport routier", "Stockage & emballage", "Développement de marchés"],
  about: {
    eyebrow: "01 — À propos",
    title: "Un consultant, un réseau, _une méthode_ pour grandir à l'international.",
    body1: "MF Logistics Consulting Group offre aux entreprises un interlocuteur unique lorsqu'elles décident de vendre, d'acheter ou de produire au-delà des frontières nationales.",
    body2: "Nous associons expertise documentaire, connaissance des marchés et logistique opérationnelle pour transformer une idée d'expansion en un flux concret de marchandises, de contrats et de relations.",
  founderRole: "Fondatrice & CEO",
  founderLine: "Une longue expérience internationale en Europe et dans le monde : j'accompagne les entreprises au-delà des frontières, avec soin et méthode.",
  doorCaption: "Ma porte est toujours ouverte",
    pillars: [
      { t: "Vision d'ensemble", d: "Stratégie commerciale, documents et transport pensés comme un seul projet." },
      { t: "Exécution concrète", d: "Nous suivons chaque expédition et chaque dossier jusqu'au bout." },
      { t: "Réseau de contacts", d: "Partenaires, fournisseurs et acheteurs sélectionnés sur les marchés cibles." },
    ],
  },
  services: {
    eyebrow: "02 — Services",
    title: "Un conseil sur mesure, _du papier_ au conteneur.",
    intro: "Chaque entreprise est unique : nous construisons le parcours adapté à la vôtre.",
    items: [
      { t: "Import & Export", d: "Planification des flux, Incoterms, fournisseurs et partenaires logistiques pour acheter et vendre à l'étranger en toute sécurité." },
      { t: "Procédures documentaires", d: "Douane, certificats d'origine, documents de transport et conformité réglementaire gérés avec précision." },
      { t: "Lancement de produits", d: "Analyse du marché cible, conditions d'accès et stratégie de lancement de vos produits." },
      { t: "Développement sur les marchés", d: "Plans d'internationalisation et croissance commerciale dans de nouveaux pays et canaux." },
      { t: "Développement de contacts", d: "Recherche et qualification d'acheteurs, distributeurs et partenaires sur le marché visé." },
      { t: "Commandes des marchés étrangers", d: "Recherche de clients internationaux et gestion de leurs demandes de commande, du premier contact à la commande confirmée." },
      { t: "Conseil aux entreprises", d: "Accompagnement sur l'organisation, les processus et tout autre besoin lié à votre activité." },
    ],
  },
  logistics: {
    eyebrow: "03 — Logistique",
    title: "Toute marchandise, _toute_ route.",
    intro: "Nous organisons des expéditions complètes pour tout type de marchandise et de mode de transport, stockage et emballage compris.",
    modesTitle: "Modes de transport",
    modesDesc: "Nous combinons navire, avion, route et express pour équilibrer délais, coûts et sécurité.",
    modes: ["Navire", "Avion", "Route", "Express"],
    goodsTitle: "Types de marchandises",
    goods: [
      { t: "Température ambiante — General cargo", d: "Marchandise générale, groupage et chargements complets." },
      { t: "Température dirigée", d: "Chaîne du froid et plages thermiques dédiées." },
      { t: "Marchandises dangereuses DGR", d: "Gestion documentaire et opérationnelle ADR / IMDG / IATA." },
    ],
    subsLabel: "Sous-catégories de charge",
    subs: ["Aliments & périssables (même surgelés)", "Pharmaceutique", "Machines & équipements", "Biens de luxe", "Vêtements", "Cosmétiques", "…et plus"],
    insurance: { t: "Assurance marchandise", d: "Protection complète de votre cargaison sur chaque tronçon." },
    docsPermits: { t: "Documents & permis", d: "Enregistrements, certificats sanitaires, permis d'entrée et chaque formalité." },
    palletControl: { t: "Palettisation & contrôle", d: "Stockage, palettisation et contrôle des marchandises en entrepôt." },
    warehousing: { t: "Stockage", d: "Entreposage, gestion des stocks et distribution." },
    packaging: { t: "Emballage", d: "Emballages adaptés à la marchandise, au mode et aux normes." },
    customs: { t: "Documents & douane", d: "Du connaissement au certificat : chaque papier à sa place." },
  },
  newsletter: {
    eyebrow: "L'infolettre",
    titleAccent: "Restez au fait",
    title: " du monde.",
    sub: "Chaque mois : routes, marchés et conseils pratiques pour vendre et acheter au-delà des frontières. Sans spam.",
    placeholder: "Votre email",
    cta: "S'abonner",
    sending: "Envoi…",
    ok: "Abonnement confirmé ! Vous recevrez nos actualités.",
    already: "Vous êtes déjà abonné.",
    error: "Une erreur est survenue. Veuillez réessayer.",
    privacy: "En vous abonnant, vous acceptez de recevoir nos communications. Sans spam : désinscription à tout moment.",
  },
  clients: {
    eyebrow: "04 — Clients",
    title: "Des entreprises qui ont choisi _nos services_.",
    intro: "Quelques-unes des entreprises que nous avons accompagnées sur les marchés internationaux.",
    consTitle: "Avec le _conseil_.",
    impTitle: "Avec l'_import-export_.",
    placeholder: "[Logo client]",
    visit: "Visiter",
  },
  contact: {
    eyebrow: "05 — Contact",
    title: "Dites-nous _où_ vous voulez aller.",
    intro: "Écrivez-nous : nous vous recontacterons pour définir ensemble le meilleur parcours.",
    fields: { name: "Nom et prénom", company: "Entreprise", email: "E-mail", phone: "Téléphone", service: "De quoi avez-vous besoin ?", message: "Message" },
    servicePick: "Choisir un service",
    logisticsOption: "Expéditions & logistique",
    submit: "Envoyer la demande",
    sending: "Envoi en cours…",
    success: "Merci ! Nous avons bien reçu votre demande et vous recontacterons rapidement.",
    error: "Échec de l'envoi. Vérifiez les champs et réessayez.",
    direct: "Contact direct",
    emailLabel: "E-mail",
    phoneLabel: "Téléphone",
    vatLabel: "N° TVA",
    addressLabel: "Siège",
  },
  footer: { tagline: "Conseil aux entreprises, import-export et logistique internationale.", rights: "Tous droits réservés.", admin: "Espace réservé", top: "Haut de page" },
};
export default fr;
